<div class="search-container">
  <div class="top-content">
    <div class="full-mid-sec">
      <div class="input-container">
        <input
          disabled
          type="text"
          class="search-input"
          [style]="'fontSize.24' | translate"
          placeholder="{{ 'search_hint' | translate }}"
          (keyup)="onKeyUp($event)"
          [(ngModel)]="state.searchText"
          maxlength="50"
        />
      </div>
      <div class="mid-key" *ngIf="!state.isGridFocused">
        <div style="width: 26.72vw">
          <div
            class="previous-searches vertical-focusable-container"
            [style]="'fontSize.24' | translate"
            data-right="alphanumeric-keypad"
            [attr.data-down]="
              this.facets?.terms?.length > 0
                ? 'facets-container'
                : 'items-wrapper'
            "
            *ngIf="
              (state.searchText.trim() === '' ||
                !state.isSearchedAndNoResult) &&
              !recentSearchesLoading
            "
            [ngStyle]="{ opacity: recentSearches?.length > 0 ? 1 : 0 }"
          >
            <button
              tabindex="{{ i }}"
              class="previous-search focusable-element"
              [style]="'fontSize.24' | translate"
              *ngFor="
                let search of recentSearches;
                let i = index;
                trackBy: trackByIndex
              "
              (keydown.ArrowLeft)="openVerticalMenu('previous-searches', i)"
              (click)="onPreviousSearchClick(search.text)"
              (keydown.ArrowDown)="previousSearchArrowDown(i)"
            >
              {{ search.text }}
            </button>
          </div>
          <div class="no-results" *ngIf="state.isSearchedAndNoResult">
            <h2 [style]="'fontSize.28' | translate">
              {{ "search_no_result" | translate }}
            </h2>
            <p
              [style]="'fontSize.24' | translate"
              [innerHTML]="'search_no_result_desc' | translate"
            ></p>
          </div>
        </div>
        <app-alphanumeric-keypad
          (keyPress)="onKeyPress($event)"
          (space)="addSpace()"
          (clear)="clearSearch()"
          (backspace)="backspace()"
          (focusLeft)="fromKeyboardLeft()"
          (focusDown)="fromKeyboardDown()"
        ></app-alphanumeric-keypad>
      </div>
    </div>
  </div>
  <div
    class="bottom-content"
    [ngClass]="{ focused: state.isGridFocused }"
    *ngIf="resources?.length > 0"
  >
    <div class="search-results-header">
      <h2
        class="results-title"
        [style]="'fontSize.28' | translate"
        *ngIf="state.isSearched"
      >
        {{ localizedTitle | translate }}
      </h2>
      <div
        class="facets-container horizontal-focusable-container"
        *ngIf="facets?.terms?.length > 0 && state.isSearched"
        (keydown.ArrowDown)="fromFacetsDown()"
        (keydown.ArrowUp)="fromFacetsUp()"
      >
        <button
          *ngFor="
            let facetTerm of facets.terms;
            let i = index;
            trackBy: trackByIndex
          "
          [style]="'fontSize.20' | translate"
          class="facet-button focusable-element"
          [class.selected]="selectedFacetIndex === i && focusedFacetIndex !== i"
          (focus)="onFacetFocus(facetTerm.term, i)"
          tabindex="0"
          (focusin)="isFromKeyboard = true"
          (keydown.ArrowLeft)="
            i == 0 && openVerticalMenu('facets-container', 0)
          "
        >
          <span class="facet-text">{{ facetTerm.term }}</span>
        </button>
      </div>
    </div>
    <app-grid
      (keydown)="paginate($event)"
      [isSearchPage]="true"
      [data]="resources"
      [showHeader]="state.isSearched ? false : true"
      [header]="localizedTitle | translate"
      [aspectRatio]="state.isSearched ? '16x9' : '2x3'"
      (isFocused)="isGridFocused($event)"
      (focusLeft)="fromGridLeft()"
      (focusUp)="fromGridUp()"
      [shouldReuse]="true"
      (clicked)="onClick($event)"
    ></app-grid>
  </div>
</div>
